import { useSupport } from '../../../../../../context/support/SupportContext';
import TicketHeader from './sections/TicketHeader';
import TicketMessageStream from './sections/TicketMessageStream';
import TicketMessageInput from './sections/TicketMessageInput';

const TicketConsole = () => {
  const { selectedTicket, chatEndRef } = useSupport();

  if (!selectedTicket) return null;

  return (
    <div className="flex-1 flex flex-col overflow-hidden">
      <TicketHeader selectedTicket={selectedTicket} />
      <TicketMessageStream selectedTicket={selectedTicket} chatEndRef={chatEndRef} />
      <TicketMessageInput selectedTicket={selectedTicket} />
    </div>
  );
};

export default TicketConsole;
